import type { AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { useInstitution } from "@/shared/stores/institution";
import { useAuth } from "@/shared/stores/auth";

const TOKEN_TYPE = "Bearer";
const REFRESH_TOKEN_URL = "/auth/refresh";

export function setupRequestInterceptor(api: AxiosInstance) {
  api.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      const institutionStore = useInstitution();
      const authStore = useAuth();

      if (institutionStore.institutionId) {
        config.headers["InstitutionId"] = institutionStore.institutionId;
      }

      if (authStore.accessToken && config.url !== REFRESH_TOKEN_URL) {
        config.headers.Authorization = `${TOKEN_TYPE} ${authStore.accessToken}`;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );
}
